export abstract class Base {

  constructor(
    public Id?: number,
    public Identifier?: string,
    public OverallCount?: number
  ) { }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/base.model.ts